// src/App.tsx

import React from "react";
// @ts-ignore
import WarGamingModule from "./WarGamingModule";
import { ChevronLeft, Home } from "lucide-react";

import "./styles.css"; // This imports the Tailwind CSS styles

export default function App() {
  return (
    <div className="bg-gray-50 font-sans min-h-screen">
      {/* Left Vertical Sidebar */}
      <aside className="fixed top-0 left-0 h-full w-64 bg-white border-r border-gray-200 z-30 flex flex-col">
        {/* Logo at the top */}
        <div className="p-6 border-b border-gray-200">
          <div className="overflow-hidden">
            <a href="/">
              <img
                src="https://cdn.freebiesupply.com/logos/large/2x/kpmg-1-logo-png-transparent.png"
                alt="KPMG Logo"
                className="w-full h-auto -mt-12 -mb-12"
              />
            </a>
          </div>
        </div>
        
        {/* Navigation Links */}
        <nav className="flex-grow p-4">
          <ul className="space-y-2">
            <li>
              {/* FIX: Added target="_blank" to open the link in a new tab */}
              <a 
                href="https://54.68.168.87.nip.io/myapp/" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
              >
                <ChevronLeft className="w-5 h-5 mr-3" />
                <span>Back to Home</span>
              </a>
            </li>
            <li>
              <a 
                href="/" 
                className="flex items-center p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
              >
                <Home className="w-5 h-5 mr-3" />
                <span>Scenario Modeler</span>
              </a>
            </li>
          </ul>
        </nav>
      </aside>

      {/* Main content now has a left margin to avoid being overlapped by the sidebar */}
      <div className="ml-64">
        <main>
          <WarGamingModule />
        </main>
      </div>
    </div>
  );
}
